const getAnchor = () => {
  const currentUrl = document.URL;
  const urlParts = currentUrl.split('#');

  return (urlParts.length > 1) ? urlParts[1] : null;
}

const handleResize = (links) => {
  for (let i = 0; i < links.length; i++) {
    const e = links[i];
    if (e instanceof HTMLElement) {
      e.style.height = e.offsetWidth + 'px';
    }
  }
};

const handleSwitch = toShow => {
  const sections = document.getElementsByClassName('link-grid__single');
  const container = document.getElementsByClassName('link-grid__content-container')[0];
  const yOffset = -50;
  const y = container.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({top: y, behavior: 'smooth'});

  Array.from(sections).forEach(section => {
    if (toShow === section.dataset.name) {
      setTimeout(() => {
        section.classList.add('show', 'keep-height');
      }, 250);
    } else {
      section.classList.remove('show');

      setTimeout(() => {
        section.classList.remove('keep-height');
      }, 250);
    }
  });
};

const initLinkGrid = (links) => {
  handleResize(links);

  window.addEventListener('resize', () => {
    handleResize(links);
  });

  Array.from(links).forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const currentUrl = document.URL;
      const urlParts = currentUrl.split('#');
      const nextURL = urlParts[0] + '#' + e.target.dataset.link;

      window.history.pushState(null, null, nextURL);
      handleSwitch(e.target.dataset.link);
    });
  });

  if (getAnchor()) {
    handleSwitch(getAnchor());
  } else {
    const firstSection = document.getElementsByClassName('link-grid__single')[0];

    firstSection.classList.add('show', 'keep-height');
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const links = document.getElementsByClassName('link-grid__link');
  const linkContainer = document.getElementsByClassName('link-grid');
  let isAltLinkList;

  if (linkContainer.length > 0) {
    isAltLinkList = linkContainer[0].classList.contains('link-grid--alt');
  }

  if(!isAltLinkList && links.length > 0) {
    initLinkGrid(links);
  } else if(links.length > 0) {
    handleResize(links);

    window.addEventListener('resize', () => {
      handleResize(links);
    });
  };
});
